import * as net from 'util/Net';

interface AuthorizeOAuthClientArgs {
  client_id: string;
  redirect_uri: string;
  response_type: string;
  state?: string;
}

interface AuthorizeOAuthClientResponse {
  location: string;
}

export function authorizeOAuthClient(data: AuthorizeOAuthClientArgs): Promise<AuthorizeOAuthClientResponse> {
  return net.postJSONPromise({url: '/oauth/authorize', data});
}
